import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Card, Input, Space, Table, Typography, Select } from "antd";
import { t } from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import { PERMISSIONS, useUser } from "../../core/context/UserContext";
import { useModal } from "../../core/context/ModalContext";
import InstitutionCreateEdit from "./InstitutionCreateEdit";

export default function InstitutionList() {
    const history = useHistory();
    const { openModal, closeModal } = useModal()
    const { firmSettings, user, hasPermission } = useUser();
    const [institutions, setInstitutions] = useState([]);
    const [filteredData, setFilteredData] = useState([])
    const [enableFilter, setEnableFilter] = useState(true);
    const { Option } = Select;

    const getInstitutions = async (enabled) => {
        const res = await ApiService.Institution.GetInstitutionList(enabled);

        if (res.success) {
            setInstitutions(res.data);
        }
    }

    const deleteInstitution = async (institutionId) => {
        const res = await ApiService.Institution.DeleteInstitution(institutionId)
        if (res.success) {
            await getInstitutions();
        }
    }

    useEffect(() => {
        getInstitutions(enableFilter)
    }, [])

    const editInstitution = async (institutionId) => {
        openModal(t(''), (
            <InstitutionCreateEdit
                showFirmSettings={true}
                institutionId={institutionId}
                editable={hasAccess(institutionId)}
                onOk={(id) => {
                    closeModal()
                    editInstitution(id)
                }}
            />
        ), async () => {
            await getInstitutions(enableFilter);
            closeModal()
        })
    }

    const hasAccess = (institutionId) => {
        if (
            user?.institutionFirms?.find(x => x.institutionId === institutionId)
            || hasPermission(PERMISSIONS.FIRM_INSTITUTION_MANAGER)
        )
            return true;
    }

    const renderAction = (row) => {
        return (
            <Space>
                <a key="edit" onClick={() => editInstitution(row.id)}>{t('Show')}</a>
                {
                    hasPermission(PERMISSIONS.FIRM_INSTITUTION_MANAGER) && (
                        <a key="delete" onClick={async () => {
                            await deleteInstitution(row.id)
                        }} style={{ color: 'red' }}>{t('Delete')}</a>
                    )
                }
            </Space>
        )
    }

    useEffect(() => {
        setFilteredData(institutions)
    }, [institutions])

    return (
        <SimpleLayout fullWidth={true}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Button size={'small'} onClick={() => editInstitution()} type={'primary'}>{t('New')}</Button>
                    <Button size={'small'} onClick={getInstitutions}>{t('Refresh')}</Button>
                    <Input
                        size={'small'}
                        placeholder={t('Search')}
                        onChange={(e) => {
                            if (!e.target.value) {
                                setFilteredData(institutions);
                                return
                            }

                            setFilteredData(institutions.filter(x => {
                                return x.name.toLocaleUpperCase(firmSettings?.locale).includes(e.target.value.toLocaleUpperCase(firmSettings?.locale))
                            }))
                        }}
                    />
                    <Select
                        allowClear
                        size="small"
                        placeholder={t("Enable")}
                        style={{ width: 120 }}
                        value={enableFilter}
                        onChange={(value) => {
                            setEnableFilter(value);
                            getInstitutions(value);
                        }}
                    >
                        <Option value={true}>{t("Active")}</Option>
                        <Option value={false}>{t("Passive")}</Option>
                    </Select>
                </Space>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    columns={[
                        { key: 'name', dataIndex: 'name', title: t('Name') },
                        { key: 'type', dataIndex: 'type', title: t('Type'), render: (text, row) => row?.institutionType?.name },
                        { key: '#', dataIndex: '#', title: '#', render: (text, row) => renderAction(row) },
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}
